var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#16b287",
    stroke: "#16b287",
    strokeWidth: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#16b287;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#16b287;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.0723,20.7261a12.4759,12.4759,0,0,1,3.6466-5.6695c-.9317-.7453,0-5.3767,0-5.3767s3.7264,1.65,4.3918,2.4221c0,0,2.8747-3.4868,11.2059-3.4868S43.5,15.0566,43.5,23.654s-6.2285,11.339-6.2285,11.339a19.9775,19.9775,0,0,1-1.4905,4.3918H32.48A21.3853,21.3853,0,0,1,31.07,36.8562s-2.6351.3194-4.525.3194a23.0513,23.0513,0,0,1-3.966-.4259,6.4031,6.4031,0,0,1-.9316,2.6351H18.0538c-1.1179-.9582-1.6769-3.9659-1.6769-3.9659S7.327,31.32,5.4105,28.871c-1.038-1.9431-.905-6.2551-.905-6.2551A7.9406,7.9406,0,0,1,8.0723,20.7261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5444,13.7789a11.5482,11.5482,0,0,1,7.3464-2.156,13.1871,13.1871,0,0,1,7.9852,2.5287"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.6124,
    cy: 21.285,
    r: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLending);
export default __webpack_public_path__ + "static/media/Lending.ee5915411155a62fa0db5c91e1a114ca.svg";
export { ForwardRef as ReactComponent };